import React from 'react'
import { FieldArray } from 'formik'
import styles from './OrderTransactionsGroupForm.module.css'
import { newTransactionFormValues } from './OrderTransactionForm/formValues'
import { OrderTransactionForm } from './OrderTransactionForm/OrderTransactionForm'
import { PrimaryButton } from 'components/Shared/PrimaryButton'
import { ReactComponent as AddIcon } from 'assets/icons/add-red.svg'
import { useTranslation } from 'react-i18next'
import { TransactionType } from './OrderTransactionForm/TransactionType'

export function OrderTransactionsGroupForm ({
  name,
  defaultContractor,
  type,
  transactions,
  onContractorCreated,
  transactionServiceTypes,
  onCostRemoved = () => {},
  disabled,
  isTransactionDisabled
}) {
  const { t } = useTranslation()

  if (!transactions) return null

  const addTransaction = arrayHelpers => {
    const transaction = newTransactionFormValues(type, defaultContractor)
    arrayHelpers.insert(transactions.length, transaction)
  }

  const removeTransaction = (arrayHelpers, index) => {
    arrayHelpers.remove(index)
    if (type === TransactionType.Cost) {
      onCostRemoved(index)
    }
  }

  return (
    <div className={styles.container}>
      <FieldArray
        name={name}
        render={arrayHelpers => (
          <>
            {transactions.map((_, index) => (
                <OrderTransactionForm
                  key={index}
                  name={`${name}.${index}`}
                  transactionType={type}
                  number={index + 1}
                  onRemoveClick={() => removeTransaction(arrayHelpers, index)}
                  onContractorCreated={(contractor) => onContractorCreated(contractor)}
                  transactionServiceTypes={transactionServiceTypes}
                  disabled={disabled || isTransactionDisabled(index)}
                />
              )
            )}
            {!disabled && <div className={styles.formActionsRow}>
              <PrimaryButton
                type="button"
                label={t(`form.order.transaction.add.${type}`)}
                onClick={() => addTransaction(arrayHelpers)}
                icon={<AddIcon/>}
                className={styles.addTransactionButton}
              />
            </div>
            }
          </>
        )}
      />
    </div>
  )
}
